import { Injectable } from '@angular/core'
import { Effect, Actions, ofType } from '@ngrx/effects'
import { Router } from '@angular/router'
import { Location } from '@angular/common'
import { map, tap } from 'rxjs/operators'

import * as App from '../actions/app.actions'
import { NotificationService } from '../../shared/notifications/notification.service'
import { SoundService } from '../../shared/sound/sound.service'

@Injectable()
export class AppEffects {

  constructor(private actions$: Actions,
              private router: Router,
              private soundService: SoundService,
              private location: Location,
              private notificationService: NotificationService) {
  }

  @Effect({dispatch: false})
  apiCallSuccess$ = this.actions$.pipe(
    ofType(App.API_CALL_SUCCESS),
    map((action: any) => action.payload),
    tap(({title, msg}) => this.notificationService.showSuccessNotification(title, msg)))

  @Effect({dispatch: false})
  apiCallFailure$ = this.actions$.pipe(
    ofType(App.API_CALL_FAILURE),
    map((action: any) => action.payload),
    tap(({title, msg}) => {
      this.soundService.playError()
      this.notificationService.showErrorNotification(title, msg)
    }))

  @Effect({dispatch: false})
  apiCallInfo$ = this.actions$.pipe(
    ofType(App.API_CALL_INFO),
    map((action: any) => action.payload),
    tap(({title, msg}) => this.notificationService.showInfoNotification(title, msg)))

  @Effect({dispatch: false})
  navigate$ = this.actions$.pipe(
    ofType(App.GO),
    map((action: App.Go) => action.payload),
    tap(({path, query: queryParams, extras}) => {
      this.router.navigate(path, {queryParams, ...extras})
    }))

  @Effect({dispatch: false})
  navigateBack$ = this.actions$.pipe(
    ofType(App.BACK),
    tap(() => this.location.back()))

  @Effect({dispatch: false})
  navigateForward$ = this.actions$.pipe(
    ofType(App.FORWARD),
    tap(_ => this.location.forward()))
}



// WEBPACK FOOTER //
// ./src/app/store/effects/app.effects.ts